<template>
	<div class="help">
		<p class="help-con">©️58帮助中心</p>
	</div>
</template> 

<script>
export default {
	name: 'help',
	props: {}
}
</script>

<style lang="scss" scope>
	.help {
		border-top: 1px solid #eaeaea;
		padding: 28px 0;
	}
	.help-con {
		font-size: 14px;
		color: #999999;
		letter-spacing: 0;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// Help.vue?f4c3bd64